import { Link } from "react-router-dom";

export default function About() {
  return (
    <article className="max-w-prose space-y-6">
      <h1 className="text-3xl font-semibold">About</h1>

      <p>
        This is a collaborative voting platform for the 100 hardest questions a country
        normally outsources to a head of state, a parliament, or a constitutional
        drafting committee. Lebanon first. The framework is generic to any country.
      </p>

      <p>
        Each question carries the historical context, the findings, and the
        trade-offs — so a vote is informed, not impressionistic. The platform takes
        no editorial position on any question and surfaces no recommended answer.
        The point is what the people choose, not what any author thinks they should.
      </p>

      <h2 className="text-xl font-semibold mt-8">Privacy and anonymity</h2>
      <ul className="list-disc pl-5 space-y-1">
        <li>
          Email is collected for magic-link auth. It is never tied to votes in any
          public response.
        </li>
        <li>
          Username is your public handle but is also never tied to votes in any public
          response.
        </li>
        <li>One vote per question per user, enforced at the database level.</li>
        <li>
          Cohort filters (residency, age, region, optional sect) are aggregated only.
          When a filter is applied, breakdowns under 10 votes per question are
          suppressed (k-anonymity).
        </li>
        <li>Votes can be changed at any time. The most recent vote stands.</li>
      </ul>

      <h2 className="text-xl font-semibold mt-8">v0 limits — published honestly</h2>
      <ul className="list-disc pl-5 space-y-1">
        <li>
          Email-only registration is Sybil-vulnerable. A motivated actor can create
          many accounts.
        </li>
        <li>
          Results are <strong>consultative, not constitutionally binding</strong>. We
          will say this on every page.
        </li>
        <li>
          The platform is in English at v0. Arabic (canonical) and French translations
          are planned at v1.0.
        </li>
        <li>
          Identity verification (national ID / trusted OAuth) is planned for v1, after
          which results gain stronger civic standing.
        </li>
      </ul>

      <h2 className="text-xl font-semibold mt-8">License</h2>
      <p>
        Platform source code is licensed under AGPL 3.0. The 100 questions and their
        context are licensed under{" "}
        <a
          href="https://creativecommons.org/licenses/by-sa/4.0/"
          target="_blank"
          rel="noreferrer"
        >
          CC BY-SA 4.0
        </a>
        . Anyone may fork the platform for any country, region, or constitutional
        moment.
      </p>

      <p>
        <Link to="/themes">Start voting →</Link>
      </p>
    </article>
  );
}
